import { ReactNode } from "react";

export function HandlingTimeVariation({ children, enabled = true, as: Tag = "span" }: HandlingTimeVariationProps) {
  return enabled ? <Tag className="handlingTimeVariation">{children}</Tag> : <>{children}</>;
}

export function ArrivalDateVariation({ children, as: Tag = "span" }: ArrivalDateVariationProps) {
  return <Tag className="arrivalDateVariation">{children}</Tag>;
}

interface ArrivalDateVariationProps {
  children: ReactNode;
  as?: "span" | "div";
}

interface HandlingTimeVariationProps extends ArrivalDateVariationProps {
  enabled?: boolean;
}
